import { render, staticRenderFns } from "./IconInstrument.vue?vue&type=template&id=a0c0f08c&"
import script from "./IconInstrument.vue?vue&type=script&lang=js&"
export * from "./IconInstrument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports